<template>
    <div class="battery-icon" :class="getBatteryColor(battery)">
        {{ battery }}
    </div>
</template>
<script>

export default {
    name: 'BatteryIcon',
    props: {
        battery: {
            type: Number,
            default: 0
        },
        lostConnection: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        getBatteryColor(battery) {
            if (this.lostConnection) {
                return 'b-lost';
            }
            if (battery >= 35) {
                return 'b-full';
            } else {
                return 'b-low';
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.battery-icon{
    border-radius: 4px;
    border: 1px solid #C4CCD9;
    background-color: #EEF1F4;
    padding: 1px 4px;
    min-width: 29px;
    margin-right: 3px;
    @include display-flex();
    @include justify-content(center);
    @include align-items(center);

    @include font-size(10px);
    line-height: 15px;
    font-family: $text;
    position: relative;
    z-index: 1;

    &::before{
        content: '';
        position: absolute;
        top: 50%;
        left: 100%;
        width: 3px;
        border-radius: 0px 4px 4px 0px;
        height: 6px;
        background-color: #C4CCD9;
        transform: translateY(-50%);
    }

    &.b-full{
        border-color: #C4CCD9;

        &::before{
            background-color: #C4CCD9;
        }
    }

    &.b-low{
        border-color: $color-error-500;
        color: $color-error-500;
        background-color: $color-error-100;

        &::before{
            background-color: $color-error-500;
        }
    }

    &.b-lost{
        border-color: $error-dark;
        color: $error-dark;
        background-color: $error-t90;

        &::before{
            background-color: $error-dark;
        }
    }
}
</style>